import { useEffect, useMemo, useRef, useState } from 'react'
import { Table, TextDateFormat, BadgeFormStatus, BadgeFormApproveStatus, TableButtonFormUserGroup } from '../shared'
import { useUserContext } from '../../context/userContext'
import { getFormRequests, deleteFormRequest } from '../../classes/FormRequest'
// import { errorHandle } from '../../api/api'
import { useToast } from '@chakra-ui/react'
import { ModalFormInfo } from '../shared'
import SelectedItemAlertContext, { defaultSelectData } from '../../context/selectedItemAlertContext'
import DialogConfirm from '../shared/DialogConfirm'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'

const TableUserForm = () => {
    const { userData } = useUserContext()
    const columns = useMemo(() => [
        {
            Header: 'ขอเข้าพักอาคาร',
            accessor: 'residence_name',
        },
        {
            Header: 'วันที่ยื่น',
            accessor: 'submit_date',
            Cell: ({ value }) => <TextDateFormat value={value} />
        },
        {
            Header: 'สถานะการยื่นแบบ',
            Cell: ({ row }) => <BadgeFormStatus data={row.original} />
        },

        {
            Header: 'จัดการ',
            Cell: ({ row }) => <TableButtonFormUserGroup row={row.original} />
        },

        {
            Header: 'วันที่อนุมัติ',
            accessor: 'approve_date',
            Cell: ({ value }) => <TextDateFormat value={value} />
        },
        {
            Header: 'ผลการอนุมัติ',
            Cell: ({ row }) => <BadgeFormApproveStatus data={row.original} />
        }
    ], [])
    const [data, setData] = useState(null)
    const [itemData, setItemData] = useState(defaultSelectData)
    const toast = useToast()

    const loadData = useRef()
    loadData.current = async () => {
        await getFormRequests(userData.id, userData.token)
            .then(res => {
                // console.log('load data')
                setData(res)
            })
            .catch(error => {
                // console.log('error')
                // console.log(errorHandle(error))
                toast(toastVal({
                    title: "การดึงข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    const deleteFormHandle = async (fid) => {
        //console.log('delete handle : ' + fid)
        await deleteFormRequest(fid, userData.token)
            .then(res => {
                loadData.current()
                toast(toastVal({
                    title: "ดำเนินการลบ สำเร็จ",
                    description: `ลบแบบคำร้อง เรียบร้อยแล้ว`,
                }))
            })
            .catch(error => {
                toast(toastVal({
                    title: "การดำเนินการลบ ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    useEffect(() => {
        loadData.current()
    }, [])

    return (
        <SelectedItemAlertContext.Provider value={[itemData, setItemData]} >
            {data && <Table columns={columns} data={data} />}
            <DialogConfirm data={itemData} deleteHandle={deleteFormHandle} />
            <ModalFormInfo data={itemData} />
        </SelectedItemAlertContext.Provider>

    )
}

export default TableUserForm
